import React from "react";
import { Link } from "react-router-dom";
import "./AdminDashboard.css";

const AdminDashboard = () => {
    return (
        <div className="admin-dashboard">
            <h1>Panel de Administración</h1>
            <div className="admin-dashboard-grid">
                <Link to="/Inventario" className="admin-dashboard-card">
                    <span role="img" aria-label="Inventario">📦</span>
                    <h2>Inventario</h2>
                    <p>Gestiona el inventario de productos.</p>
                </Link>
                <Link to="/Contabilidad" className="admin-dashboard-card">
                    <span role="img" aria-label="Contabilidad">📊</span>
                    <h2>Contabilidad</h2>
                    <p>Administra las finanzas y registros contables.</p>
                </Link>
                <Link to="/Pedidos" className="admin-dashboard-card">
                    <span role="img" aria-label="Pedidos">📦</span>
                    <h2>Pedidos y Despachos</h2>
                    <p>Gestiona pedidos y envíos.</p>
                </Link>
                <Link to="/Usuarios" className="admin-dashboard-card">
                    <span role="img" aria-label="Usuarios">👥</span>
                    <h2>Gestión de Usuarios</h2>
                    <p>Administra los usuarios del sistema.</p>
                </Link>
                <Link to="/gestion-clientes" className="admin-dashboard-card">
                    <span role="img" aria-label="Clientes">👤</span>
                    <h2>Gestión de Clientes</h2>
                    <p>Administra la información de los clientes.</p>
                </Link>
                <Link to="/Domicilios" className="admin-dashboard-card">
                    <span role="img" aria-label="Domicilios">🚚</span>
                    <h2>Domicilios</h2>
                    <p>Gestiona los servicios de domicilios.</p>
                </Link>
                <Link to="/Comisiones" className="admin-dashboard-card">
                    <span role="img" aria-label="Comisiones">💰</span>
                    <h2>Comisiones</h2>
                    <p>Gestiona las comisiones de los trabajadores.</p>
                </Link>
            </div>
        </div>
    );
};

export default AdminDashboard;